module.exports = __webpack_public_path__ + "static/media/02.c62886f8.png";